const BxfTabBarConstants = {
    // Tab properties
    TAB_TYPE_CLASSIC: 'classic',
    TAB_TYPE_MODERN: 'modern',
    WIDTH_TYPE_TRUNCATED: 'truncated',
    WIDTH_TYPE_FULL: 'full',
    // Listener Events
    SCROLL: 'scroll',
    // Controls
    TIMER_PRESS_DELAY: 500,
    TIMER_PRESS_REPEAT: 50,
    RESIZE_DEBOUNCE_DELAY: 1000,
    SCROLL_FACTOR: 0.05,
    // Tab detail specifiers
    LEFT_NAV_ICON: 'arrow-left',
    RIGHT_NAV_ICON: 'arrow-right',
    LEFT_NAV_LABEL: 'Scroll Left',
    RIGHT_NAV_LABEL: 'Scroll Right',
    ADD_TAB_LABEL: 'Add Tab',
    ADD_BUTTON_ICON: 'add',
    ICON_STATE: 'tertiary-button',
    UID: 'uid',
    TAG_NAME: 'tagName',
    // CSS Classes
    PINNED_TABS_CONTAINER: 'bxf-tab-bar__pinned-tabs-container',
    TABS_CONTAINER: 'bxf-tab-bar__tabs-container',
    ADD_ICON_CONTAINER: 'bxf-tab-bar__add-icon-container',
    ADD_ICON_CONTAINER_MODERN: 'bxf-tab-bar__add-icon-container--modern',
    ADD_ICON_CONTAINER_CLASSIC: 'bxf-tab-bar__tabs-container--classic',
    ADD_ICON_CONTAINER_EMPTY: 'bxf-tab-bar__add-icon-container--empty',
    ADD_ICON_SPAN: 'bxf-tab__add-button--label',
    CONTAINER: 'bxf-tab-bar__container',
    CONTAINER_TABS: 'bxf-tab-bar__container--tabs',
    BOTTOM_BORDER_DIV: 'bxf-tab-bar__container-empty',
    NAV_BUTTONS: 'bxf-tab-bar__navigation-icon-container',
    NAV_BUTTONS_BOTTOM_BORDER: 'bxf-tab-bar__navigation-icon-container-with-border-bottom',
    TABS_SCROLLING_LEFT: 'bxf-tab-bar__tab-container--scrolling-left',
    TABS_SCROLLING_RIGHT: 'bxf-tab-bar__tab-container--scrolling-right',
    DRAG_GHOST: 'bxf-tab-bar__tab-bar-item-drag--ghost',
    // Tag names
    BXF_TAB_BAR_ITEM: 'bxf-tab-bar-item',
};

export { BxfTabBarConstants as B };
